import api from "data/APIs";
import { useCustomMutation } from "data/modules/api/hooks/useCustomMutation";

const useVisibilityMutations = () => {
  const createMutation = useCustomMutation({
    url: api.creator_miscellaneous_data.create,
  });

  const updateMutation = useCustomMutation({
    url: api.creator_miscellaneous_data.update,
  });

  return { createMutation, updateMutation };
};

export default useVisibilityMutations;
